import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ASSETS } from "../../../utils/config";
import SearchBar from "../../SearchBar";
import { colors } from "../../../utils";
import { EnterBetaButton } from "../../EnterBetaButton";
import UserImage from "../../UserImage";
import { isUserLoggedIn } from "../../../utils/helpers";
import { useLogout } from "../../../services/mutations";
import { logout } from "../../../redux/actions";
import { resetGallery } from "../../../redux/reducers/gallery";
import { clearGalleryPopup } from "../../../redux/reducers/galleryPopup";
import { useQueryClient } from "react-query";
import JoinIyugaButton from "../../../assets/images/join-iyuga.svg";

const Wrapper = styled.div`
  height: 9vh;
  height: 10svh;
  padding: 10px 16px 10px 16px;
  box-shadow: 0px 4px 7px 0px #00000014;
  background-color: white;
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  grid-gap: 16px;
  align-items: center;
  position: relative;
`;

const Icon = styled.img`
  width: 40px;
  height: 40px;
`;

const UserImageContainer = styled.div`
  position: relative;
  cursor: pointer;
`;

const Dropdown = styled.div`
  position: absolute;
  right: 0;
  top: 45px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
  width: 150px;
  z-index: 100;
  overflow: hidden;
`;

const DropdownItem = styled.div`
  padding: 12px 16px;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #123051;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export default function SearchHeader({
  onClickBeta,
  handleNavigate,
  navigateToSignup,
}) {
  const { userProfile } = useSelector((state) => state.userProfile);
  const [showDropdown, setShowDropdown] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userLogout = useLogout();
  const dropdownRef = useRef();
  const queryClient = useQueryClient();

  const handleLogout = () => {
    userLogout.mutate(null, {
      onSuccess: (response) => {
        dispatch(logout());
        dispatch(resetGallery());
        dispatch(clearGalleryPopup());
        localStorage.removeItem("keyCloak");
        sessionStorage.removeItem("referralData");
        queryClient.clear();
        navigate("/login");
        setShowDropdown(false);
      },
      onError: (err) => {
        console.error("Logout failed:", err);
      },
    });
  };

  const handleLogin = () => {
    navigate("/login");
    setShowDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Wrapper>
      <Icon src={ASSETS.iyugaLogo} alt="Iyuga logo" onClick={handleNavigate} />
      <SearchBar handleNavigate={handleNavigate} />

      {isUserLoggedIn() ? (
        <EnterBetaButton onClickBeta={onClickBeta} />
      ) : (
        <EnterBetaButton
          button={JoinIyugaButton}
          onlyInvite={true}
          onClickBeta={navigateToSignup}
        />
      )}

      <UserImageContainer ref={dropdownRef}>
        <UserImage
          style={{ marginRight: 10 }}
          image={userProfile?.profile_image}
          size={42}
          onClick={() => setShowDropdown(!showDropdown)}
        />

        {showDropdown && (
          <Dropdown>
            {isUserLoggedIn() ? (
              <DropdownItem onClick={handleLogout}>Sign Out</DropdownItem>
            ) : (
              <DropdownItem onClick={handleLogin}>Log In</DropdownItem>
            )}
          </Dropdown>
        )}
      </UserImageContainer>
    </Wrapper>
  );
}
